module.exports = __webpack_public_path__ + "static/ServoRange-f2492b9648ee3353c2413e3e97a164b3.png";